import { createServerFn } from "@tanstack/react-start";

export const trackPageView = createServerFn({ method: "POST" })
  .inputValidator((data: { 
    visitorId: string; 
    path: string; 
    title: string; 
    referrer: string;
    sessionId?: string;
  }) => data)
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const supabase = supabaseAdmin;
    
    let sessionId = data.sessionId;
    
    if (!sessionId) {
      const { data: session, error } = await supabase
        .from('analytics_sessions')
        .insert({
          visitor_id: data.visitorId,
          referrer: data.referrer,
          user_agent: 'Client-side',
        })
        .select()
        .single();
        
      if (error) throw error;
      sessionId = session.id;
    } else {
      await supabase
        .from('analytics_sessions')
        .update({ last_activity: new Date().toISOString() })
        .eq('id', sessionId);
    }
    
    const { data: pv, error: pvError } = await supabase
      .from('analytics_page_views')
      .insert({
        session_id: sessionId,
        path: data.path,
        title: data.title,
        referrer: data.referrer,
      })
      .select()
      .single();
      
    if (pvError) throw pvError;
    
    return { sessionId, pageViewId: pv.id };
  });

export const updatePageDuration = createServerFn({ method: "POST" })
  .inputValidator((data: { pageViewId: string; duration: number; isExit?: boolean }) => data)
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const supabase = supabaseAdmin;
    await supabase
      .from('analytics_page_views')
      .update({ 
        duration_seconds: data.duration,
        is_exit: data.isExit || false
      })
      .eq('id', data.pageViewId);
      
    return { ok: true };
  });
